import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {PaymentStatusChangedEvent} from '@platform/event-bus/domain/events/payment/payment-status-changed.event';
import {OrderSettlementService} from '@features/sales/application/services/order-settlement.service';

@Injectable({providedIn: 'root'})
export class SalesOnPaymentStatusChangedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly settlement = inject(OrderSettlementService);

  constructor() {
    this.eventBus
      .ofType(PaymentStatusChangedEvent)
      .pipe(
        tap(({payload}) => this.settlement.handleStatus(payload.orderId, payload.status)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
